import React from 'react';
import {
    commonHeaders,
    API_URL,
    ACTION_PREFIX,
    ACTION_LOGIN,
    LOGIN_STATE,
    STATE_ACTION_SET,
    STATE_ACTION_APPEND,
    STATE_ACTION_SEARCH_N_REPLACE,
    ACTION_ERROR,
    STATE_ACTION_SEARCH_N_DELETE,
    STATE_ACTION_CLEAR
} from './constants';

import {CLEAR_STATE} from '../../constants';
import {appLoadingAction, appEndLoadingAction} from '../../actions';
import Notifications from 'react-notification-system-redux';
import download from 'downloadjs';
import qs from 'qs';


export default class Api {

    constructor(store) {

        this.store = store;

        this.baseUrl = API_URL;

        this.isSafari = true;//!!navigator.userAgent.match(/Version\/[\d.]+.*Safari/);

        if (this.isSafari && window.localStorage && window.localStorage.googlead)
            this.token = window.localStorage.googlead;

    }

    annuityPayments =
        {
            get: (page = 0, pageSize = 10, loadingId, filters, customProp) => this.dataApiCall(ApiPaths.annuityPayments, customProp || "annuityPayments", {
                page: page + 1,
                itemsPerPage: pageSize, ...filters
            }, {loadingId}),
            create: (annuityPayment, loadingId, files) => this.dataApiCall(ApiPaths.annuityPayments, "annuityPayments", annuityPayment, {
                method: "POST",
                stateAction: STATE_ACTION_APPEND,
                loadingId
            }, files),
            edit: (id, properties, loadingId, files) => this.dataApiCall(`${ApiPaths.annuityPayments}/${id}`, "annuityPayments", properties, {
                method: "PUT",
                stateAction: STATE_ACTION_SEARCH_N_REPLACE,
                loadingId
            }, files),
            delete: (id, loadingId) => this.dataApiCall(`${ApiPaths.annuityPayments}/${id}`, "annuityPayments", {id}, {
                method: "DELETE",
                stateAction: STATE_ACTION_SEARCH_N_DELETE,
                loadingId
            }),
            exportUrl: (filters, type = 'xlsx', title = 'Pagos de anualidades') => {
                const reportConfig = {
                    name: `${title}.${type}`,
                    title,
                    headers: {
                        'membership.id': "No. de miembro AMCEMIG",
                        'membership.ihsMemberNumber': "No. de miembro IHS",
                        'membership.person.name': 'Nombre',
                        'membership.person.patLastName': 'Apellido paterno',
                        'membership.person.matLastName': 'Apellido materno',
                        'membership.registrationDate': 'Miembro desde',
                        'type': 'Tipo de pago',
                        'year': 'Año pagado',
                        'paymentDate': 'Fecha de pago'
                    },
                    transStrings: {
                        'membership': 'Membresía',
                        'ihs': 'IHS'
                    }
                };
                const query = querySerialize({
                    ...filters,
                    pagination: false,
                    bearer: this.token,
                    reportConfig: JSON.stringify(reportConfig)
                });
                return `${API_URL}${ApiPaths.annuityPayments}.${type}?${query}`;
            }
        };

    appFiles =
        {
            get: (page = 0, pageSize = 10, loadingId, filters, customProp) => this.dataApiCall(ApiPaths.appFiles, customProp ? customProp : "appFiles", {
                page: page + 1,
                itemsPerPage: pageSize, ...filters
            }, {loadingId}),
            getRoot: (loadingId) => this.dataApiCall(ApiPaths.appFiles + "/root", "appFilesRoot", undefined, {loadingId}),
            create: (parent, isFolder, name, file, loadingId) => this.dataApiCall(ApiPaths.appFiles, "appFiles", {
                parent,
                isFolder,
                name
            }, {method: "POST", stateAction: STATE_ACTION_APPEND, loadingId}, file ? {file} : undefined),
            delete: (id, loadingId) => this.dataApiCall(`${ApiPaths.appFiles}/${id}`, "appFiles", {id}, {
                method: "DELETE",
                stateAction: STATE_ACTION_SEARCH_N_DELETE,
                loadingId
            }),


            getBlob: (id) => this.pathToBlob(`${ApiPaths.appFileDownload}/${id}`),
            download: (id) => this.downloadFile(`${ApiPaths.appFileDownload}/${id}`),
            getUrl: (id) => `${this.baseUrl}${ApiPaths.appFileUrl}/${id}`,
            getDownloadUrl: (id) => `${this.baseUrl}${ApiPaths.appFileDownload}/${id}`,
        };

    certificates =
        {
            get: (page = 0, pageSize = 10, loadingId, filters) => this.dataApiCall(ApiPaths.certificates, "certificates", {
                page: page + 1,
                itemsPerPage: pageSize, ...filters
            }, {loadingId}),
            create: (certificate, loadingId, files) => this.dataApiCall(ApiPaths.certificates, "certificates", certificate, {
                method: "POST",
                stateAction: STATE_ACTION_APPEND,
                loadingId
            }, files),
            edit: (id, properties, loadingId, files) => this.dataApiCall(`${ApiPaths.certificates}/${id}`, "certificates", properties, {
                method: "PUT",
                stateAction: STATE_ACTION_SEARCH_N_REPLACE,
                loadingId
            }, files),
            delete: (id, loadingId) => this.dataApiCall(`${ApiPaths.certificates}/${id}`, "certificates", {id}, {
                method: "DELETE",
                stateAction: STATE_ACTION_SEARCH_N_DELETE,
                loadingId
            }),
            exportUrl: (filters, type) => {
                const reportConfig = {
                    name: `Constancias.${type}`,
                    title: 'Constancias',
                    headers: {
                        'name': "Nombre",
                        'congress.name': 'Congreso'
                    }
                };
                const query = querySerialize({
                    ...filters,
                    pagination: false,
                    bearer: this.token,
                    reportConfig:
                        JSON.stringify(reportConfig)
                });
                return `${API_URL}${ApiPaths.certificates}.${type}?${query}`;
            }
        };

    clocks =
        {
            get: (loadingId, filters, customProp) => this.dataApiCall(ApiPaths.clocks, customProp ? customProp : "clocks", {}, {loadingId})
        };

    congresses =
        {
            get: (page = 0, pageSize = 10, loadingId, filters, customProp) => this.dataApiCall(ApiPaths.congresses, customProp ? customProp : "congresses", {
                page: page + 1,
                itemsPerPage: pageSize, ...filters
            }, {loadingId}),
            create: (congress, loadingId) => this.dataApiCall(ApiPaths.congresses, "congresses", congress, {
                method: "POST",
                stateAction: STATE_ACTION_APPEND,
                loadingId
            }),
            edit: (id, properties, loadingId) => this.dataApiCall(`${ApiPaths.congresses}/${id}`, "congresses", properties, {
                method: "PUT",
                stateAction: STATE_ACTION_SEARCH_N_REPLACE,
                loadingId
            }),
            delete: (id, loadingId) => this.dataApiCall(`${ApiPaths.congresses}/${id}`, "congresses", {id}, {
                method: "DELETE",
                stateAction: STATE_ACTION_SEARCH_N_DELETE,
                loadingId
            }),
            exportUrl: (filters, type = 'xlsx') => {
                const reportConfig = {
                    name: `Congresos.${type}`,
                    headers: {
                        'name': "Nombre",
                        'year': 'Año'
                    }
                };
                const query = querySerialize({
                    ...filters,
                    pagination: false,
                    bearer: this.token,
                    reportConfig: JSON.stringify(reportConfig)
                });
                return `${API_URL}${ApiPaths.congresses}.${type}?${query}`;
            }
        };

    congressAttendances =
        {
            get: (page = 0, pageSize = 10, loadingId, filters) => this.dataApiCall(ApiPaths.congressAttendances, "congressAttendances", {
                page: page + 1,
                itemsPerPage: pageSize, ...filters
            }, {loadingId}),
            import: (congressId, loadingId, file) => this.dataApiCall(`${ApiPaths.congressAttendances}/import`, "congressAttendancesImport", {congress: congressId}, {
                method: "POST",
                loadingId
            }, file),
            create: (congressAttendance, loadingId) => this.dataApiCall(ApiPaths.congressAttendances, "congressAttendances", congressAttendance, {
                method: "POST",
                stateAction: STATE_ACTION_APPEND,
                loadingId
            }),
            delete: (id, loadingId) => this.dataApiCall(`${ApiPaths.congressAttendances}/${id}`, "congressAttendances", {id}, {
                method: "DELETE",
                stateAction: STATE_ACTION_SEARCH_N_DELETE,
                loadingId
            }),
            exportUrl: (filters, type = 'xlsx') => {
                const reportConfig = {
                    name: `Asistentes a congresos.${type}`,
                    title: 'Asistentes a congresos',
                    headers: {
                        'person.membership.id': "No. de miembro",
                        'person.name': 'Nombre',
                        'person.patLastName': 'Apellido paterno',
                        'person.matLastName': 'Apellido materno',
                        'person.email': "Correo",
                        'congress.name': 'Congreso'
                    }
                };
                const query = querySerialize({
                    ...filters,
                    pagination: false,
                    bearer: this.token,
                    reportConfig: JSON.stringify(reportConfig)
                });
                return `${API_URL}${ApiPaths.congressAttendances}.${type}?${query}`;
            }
        };

    emailAddresses =
        {
            get: (page = 0, pageSize = 10, loadingId, filters, customProp) => this.dataApiCall(ApiPaths.emailAddresses, customProp ? customProp : "emailAddresses", {
                page: page + 1,
                itemsPerPage: pageSize, ...filters
            }, {loadingId}),
            getById: (id) => this.dataApiCall(`${ApiPaths.emailAddresses}/${id}`, "emailAddress", {id: id}),
            import: (mailerTags = [], loadingId, file) => this.dataApiCall(`${ApiPaths.emailAddresses}/import`, "emailAddressesImport", {mailerTags}, {
                method: "POST",
                loadingId
            }, file),
            create: (address, loadingId) => this.dataApiCall(ApiPaths.emailAddresses, "emailAddresses", address, {
                method: "POST",
                stateAction: STATE_ACTION_APPEND,
                loadingId
            }),
            edit: (id, properties, loadingId) => this.dataApiCall(`${ApiPaths.emailAddresses}/${id}`, "emailAddresses", properties, {
                method: "PUT",
                stateAction: STATE_ACTION_SEARCH_N_REPLACE,
                loadingId
            }),
            delete: (id, loadingId) => this.dataApiCall(`${ApiPaths.emailAddresses}/${id}`, "emailAddresses", {id}, {
                method: "DELETE",
                stateAction: STATE_ACTION_SEARCH_N_DELETE,
                loadingId
            }),
        };
    emailDocuments =
        {
            get: (page = 0, pageSize = 10, loadingId, filters) => this.dataApiCall(ApiPaths.emailDocuments, "emailDocuments", {
                page: page + 1,
                itemsPerPage: pageSize, ...filters
            }, {loadingId}),
            create: (emailDocument, loadingId, attachments = []) => this.dataApiCall(ApiPaths.emailDocuments, "emailDocument", emailDocument, {
                method: "POST",
                stateAction: STATE_ACTION_APPEND,
                loadingId
            }, {attachments}),
            edit: (id, properties, loadingId, attachments = []) => this.dataApiCall(`${ApiPaths.emailDocuments}/${id}`, "emailDocuments", properties, {
                method: "PUT",
                stateAction: STATE_ACTION_SEARCH_N_REPLACE,
                loadingId
            }, {attachments}),
            sendEmail: (id, emailDocument, loadingId) => this.dataApiCall(`${ApiPaths.emailDocuments}/send/${id}`, "emailDocuments", emailDocument, {
                method: "PUT",
                stateAction: STATE_ACTION_SEARCH_N_REPLACE,
                loadingId
            }),
            sendTest: (id, plainEmails, loadingId) => this.dataApiCall(`${ApiPaths.emailDocuments}/send_test/${id}`, "emailDocumentsTest", plainEmails, {
                method: "PUT",
                loadingId
            }),
            delete: (id, loadingId) => this.dataApiCall(`${ApiPaths.emailDocuments}/${id}`, "emailDocuments", {id}, {
                method: "DELETE",
                stateAction: STATE_ACTION_SEARCH_N_DELETE,
                loadingId
            }),
        };
    emailTemplates =
        {
            get: (page = 0, pageSize = 10, loadingId, filters) => this.dataApiCall(ApiPaths.emailTemplates, "emailTemplates", {
                page: page + 1,
                itemsPerPage: pageSize, ...filters
            }, {loadingId}),
        };

    emittedCertificates =
        {
            get: (page = 0, pageSize = 10, loadingId, filters, customProp) => this.dataApiCall(ApiPaths.emittedCertificates, customProp ? customProp : "emittedCertificates", {
                page: page + 1,
                itemsPerPage: pageSize, ...filters
            }, {loadingId}),
            create: (emittedCertificate, loadingId, file) => this.dataApiCall(ApiPaths.emittedCertificates, "emittedCertificates", emittedCertificate, {
                method: "POST",
                stateAction: STATE_ACTION_APPEND,
                loadingId
            }, file),
            delete: (id, loadingId) => this.dataApiCall(`${ApiPaths.emittedCertificates}/${id}`, "emittedCertificates", {id}, {
                method: "DELETE",
                stateAction: STATE_ACTION_SEARCH_N_DELETE,
                loadingId
            }),
            exportUrl: (filters, type = 'xlsx') => {
                const reportConfig = {
                    name: `Poseedores de constancias.${type}`,
                    title: 'Poseedores de constancias',
                    headers: {
                        'person.membership.id': "No. de miembro",
                        'person.name': 'Nombre',
                        'person.patLastName': 'Apellido paterno',
                        'person.matLastName': 'Apellido materno',
                        'certificate.name': 'Título de constancia'
                    }
                };
                const query = querySerialize({
                    ...filters,
                    pagination: false,
                    bearer: this.token,
                    reportConfig: JSON.stringify(reportConfig)
                });
                return `${API_URL}${ApiPaths.emittedCertificates}.${type}?${query}`;
            }
        };

    events =
        {
            get: (page = 0, pageSize = 10, loadingId, filters, customProp) => this.dataApiCall(ApiPaths.events, customProp ? customProp : "events", {
                page: page + 1,
                itemsPerPage: pageSize, ...filters
            }, {loadingId}),
            create: (event, loadingId) => this.dataApiCall(ApiPaths.events, "events", event, {
                method: "POST",
                stateAction: STATE_ACTION_APPEND,
                loadingId
            }),
            edit: (id, properties, loadingId) => this.dataApiCall(`${ApiPaths.events}/${id}`, "events", properties, {
                method: "PUT",
                stateAction: STATE_ACTION_SEARCH_N_REPLACE,
                loadingId
            }),
            delete: (id, loadingId) => this.dataApiCall(`${ApiPaths.events}/${id}`, "events", {id}, {
                method: "DELETE",
                stateAction: STATE_ACTION_SEARCH_N_DELETE,
                loadingId
            }),
            exportUrl: (filters, type = 'xlsx') => {
                const reportConfig = {
                    name: `Eventos.${type}`,
                    title: 'Eventos',
                    headers: {
                        'name': "Nombre",
                        'fromDate': 'Fecha de inicio',
                        'toDate': 'Fecha de fin'
                    }
                };
                const query = querySerialize({
                    ...filters,
                    pagination: false,
                    bearer: this.token,
                    reportConfig: JSON.stringify(reportConfig)
                });
                return `${API_URL}${ApiPaths.events}.${type}?${query}`;
            }
        };

    eventAttendances =
        {
            get: (page = 0, pageSize = 10, loadingId, filters) => this.dataApiCall(ApiPaths.eventAttendances, "eventAttendances", {
                page: page + 1,
                itemsPerPage: pageSize, ...filters
            }, {loadingId}),
            import: (eventId, loadingId, file) => this.dataApiCall(`${ApiPaths.eventAttendances}/import`, "emailAddressesImport", {event: eventId}, {
                method: "POST",
                loadingId
            }, file),
            create: (eventAttendance, loadingId, files) => this.dataApiCall(ApiPaths.eventAttendances, "eventAttendances", eventAttendance, {
                method: "POST",
                stateAction: STATE_ACTION_APPEND,
                loadingId,
                files
            }),

            delete: (id, loadingId) => this.dataApiCall(`${ApiPaths.eventAttendances}/${id}`, "eventAttendances", {id}, {
                method: "DELETE",
                stateAction: STATE_ACTION_SEARCH_N_DELETE,
                loadingId
            }),
            exportUrl: (filters, type = 'xlsx') => {
                const reportConfig = {
                    name: `Asistentes a evento.${type}`,
                    title: 'Asistentes a evento',
                    headers: {
                        'person.membership.id': "No. de miembro",
                        'person.name': 'Nombre',
                        'person.patLastName': 'Apellido paterno',
                        'person.matLastName': 'Apellido materno',
                        'event.name': 'Evento',
                        'event.congress.name': 'Congreso',
                        'event.fromDateFormatted': 'Inicio',
                        'event.toDateFormatted': 'Fin'
                    }
                };
                const query = querySerialize({
                    ...filters,
                    pagination: false,
                    bearer: this.token,
                    reportConfig: JSON.stringify(reportConfig)
                });
                return `${API_URL}${ApiPaths.eventAttendances}.${type}?${query}`;
            },
            exportPdfUrl: (filters, reportTitle) => {
                const reportConfig = {
                    name: 'Asistentes a evento.pdf',
                    title: reportTitle,
                    headers: {
                        'person.membership.id': "No. de miembro",
                        'person.name': 'Nombre',
                        'person.patLastName': 'Apellido paterno',
                        'person.matLastName': 'Apellido materno'
                        //'createdDateFormatted': 'Hora de registro'
                    }
                };
                const query = querySerialize({
                    ...filters,
                    pagination: false,
                    bearer: this.token,
                    reportConfig: JSON.stringify(reportConfig)
                });
                return `${API_URL}${ApiPaths.eventAttendances}.pdf?${query}`;
            }
        };

    mailerTags =
        {
            get: (page = 0, pageSize = 10, loadingId, filters) => this.dataApiCall(ApiPaths.mailerTags, "mailerTags", {
                page: page + 1,
                itemsPerPage: pageSize, ...filters
            }, {loadingId}),
            create: (name, loadingId) => this.dataApiCall(ApiPaths.mailerTags, "mailerTags", {name}, {
                method: "POST",
                stateAction: STATE_ACTION_APPEND,
                loadingId
            }),
            edit: (id, properties, loadingId) => this.dataApiCall(`${ApiPaths.mailerTags}/${id}`, "mailerTags", properties, {
                method: "PUT",
                stateAction: STATE_ACTION_SEARCH_N_REPLACE,
                loadingId
            }),
            delete: (id, loadingId) => this.dataApiCall(`${ApiPaths.mailerTags}/${id}`, "mailerTags", {id}, {
                method: "DELETE",
                stateAction: STATE_ACTION_SEARCH_N_DELETE,
                loadingId
            }),
        };

    logIn = (username, password) => {

        const loginError = () => {
            this.store.dispatch({
                type: ACTION_PREFIX + ACTION_LOGIN,
                payload: LOGIN_STATE.LOGIN_ERROR
            });
            this.store.dispatch(appEndLoadingAction());
        };

        this.store.dispatch(appLoadingAction());

        let credentials = new FormData();
        credentials.append("_username", username);
        credentials.append("_password", password);

        return fetch(
            this.baseUrl + ApiPaths.logIn,
            {
                method: "POST",
                body: credentials,
                credentials: 'include'
            }).then((response) => {

            if (response.status === 200) {

                if (this.isSafari) {

                    response.json().then((json) => {

                        this.token = json.token;
                        if (window.localStorage) window.localStorage.googlead = this.token;
                        this.store.dispatch({
                            type: ACTION_PREFIX + ACTION_LOGIN,
                            payload: LOGIN_STATE.LOGGED_IN
                        });
                    })

                } else {
                    this.store.dispatch({
                        type: ACTION_PREFIX + ACTION_LOGIN,
                        payload: LOGIN_STATE.LOGGED_IN
                    });
                }
                this.store.dispatch(appEndLoadingAction());
            } else if (response.status === 401) {
                this.store.dispatch({
                    type: ACTION_PREFIX + ACTION_LOGIN,
                    payload: LOGIN_STATE.BAD_CREDENTIALS
                });
                this.store.dispatch(appEndLoadingAction());
            } else if (response.status === 409) {
                this.store.dispatch({
                    type: ACTION_PREFIX + ACTION_LOGIN,
                    payload: LOGIN_STATE.LOGIN_BLOCKED
                });
                this.store.dispatch(appEndLoadingAction());
            } else {
                loginError();
            }

            return response;
        }, loginError);

    };

    logOut = () => {

        document.getElementsByTagName("html")[0].classList.remove("nav-open");

        const done = () => {
            this.store.dispatch({
                type: ACTION_PREFIX + ACTION_LOGIN,
                payload: LOGIN_STATE.NOT_LOGGED
            });
            this.store.dispatch({
                type: CLEAR_STATE
            })
        };
        fetch(API_URL + ApiPaths.logOut, {credentials: 'include'}).then(done, done);
    };

    me = (loadingId) => this.dataApiCall(ApiPaths.me, 'me', undefined, {loadingId});

    permissions =
        {
            get: (page = 0, pageSize = 200, filters, loadingId, customProp) => this.dataApiCall(ApiPaths.permissions, customProp ? customProp : "permissions", {
                page: page + 1,
                itemsPerPage: pageSize, ...filters
            }, {loadingId})
        };


    people =
        {
            get: (page = 0, pageSize = 10, loadingId, filters, customProp) => this.dataApiCall(ApiPaths.people, customProp ? customProp : "people", {
                page: page + 1,
                itemsPerPage: pageSize, ...filters
            }, {loadingId}),
            //Like get but only with id, name and last names
            getById: (id, customProp) => this.dataApiCall(`${ApiPaths.people}/${id}`, customProp || 'peopleId', {id: id}),
            getSimple: (page = 0, pageSize = 10, loadingId, filters) => this.dataApiCall(ApiPaths.peopleSimple, "peopleSimple", {
                page: page + 1,
                itemsPerPage: pageSize, ...filters
            }, {loadingId}),
            create: (person, loadingId, photo, registrationFile, academicResume) => this.dataApiCall(ApiPaths.people, "people", person, {
                method: "POST",
                stateAction: STATE_ACTION_APPEND,
                loadingId
            }, {photo, registrationFile, academicResume}),
            edit: (id, properties, loadingId, photo, registrationFile, academicResume, property) => this.dataApiCall(`${ApiPaths.people}/${id}`, property || "people", properties, {
                method: "PUT",
                stateAction: STATE_ACTION_SEARCH_N_REPLACE,
                loadingId
            }, {photo, registrationFile, academicResume}),
            delete: (id, loadingId, property) => this.dataApiCall(`${ApiPaths.people}/${id}`, property || "people", {id}, {
                method: "DELETE",
                stateAction: STATE_ACTION_SEARCH_N_DELETE,
                loadingId
            }),
            refresh: (id, loadingId, customProp) => this.dataApiCall(`${ApiPaths.people}/${id}`, customProp || "people", {id}, {
                loadingId
            }),
            downloadCredentialUrl: (id, side) => (this.baseUrl + ApiPaths.downloadCredential(id, side) + '?bearer=' + this.token),
            exportUrl: (filters, onlyMembers = true, type = 'xlsx', title = "Miembros") => {
                const reportConfig = {
                    name: `${title}.${type}`,
                    title: title,
                    headers: {
                        'membership.id': "No. de miembro AMCEMIG",
                        'membership.ihsMemberNumber': "No. de miembro IHS",
                        'membership.type': 'Tipo de miembro',
                        'membership.registrationDate': 'Miembro desde',
                        'title': 'Título',
                        'name': 'Nombre',
                        'patLastName': 'Apellido paterno',
                        'matLastName': 'Apellido materno',
                        'specialty.name': 'Especialidad',
                        'residence': 'Residencia',
                        'email': 'Email',
                        'fixedPhone': 'Teléfono fijo',
                        'mobilePhone': 'Teléfono celular'
                    }
                };


                const query = querySerialize({
                    ...filters,
                    'membership[exists]': onlyMembers,
                    'dateOfDeath[exists]': false,
                    pagination: false,
                    bearer: this.token,
                    sGroups: [
                        "person_read",
                        "membership_read",
                        "app_file_read",
                        "specialty_read",
                        "minimal_user_read",
                        "emitted_certificate_read",
                        "congress_read",
                        "certificate_read",
                        "congress_attendance_read",
                        "event_read",
                        "event_attendance_read",
                        "mailer_tag_read",
                        'person_read', 'person_mobile_phone_read', 'person_fixed_phone_read'],
                    reportConfig: JSON.stringify(reportConfig)
                });
                return `${API_URL}${ApiPaths.people}.${type}?${query}`;
            },
            downloadStatement: (id) => (this.baseUrl + ApiPaths.pdfStatement(id) + '?bearer=' + this.token),
            sendStatement: (personId, loadingId) => this.dataApiCall(`${ApiPaths.sendStatement}/${personId}`, "sendStatement", undefined, {
                method: "GET",
                stateAction: STATE_ACTION_SET,
                loadingId
            }),
        };

    unwantedIHSYears =
        {
            create: (unwantedIHSYear, loadingId) => this.dataApiCall(ApiPaths.unwantedIHSYears, "unwantedIHSYear", unwantedIHSYear, {
                method: "POST",
                stateAction: STATE_ACTION_APPEND,
                loadingId
            }),
            delete: (id, loadingId) => this.dataApiCall(`${ApiPaths.unwantedIHSYears}/${id}`, "unwantedIHSYear", {id}, {
                method: "DELETE",
                stateAction: STATE_ACTION_SEARCH_N_DELETE,
                loadingId
            })
        }
    roles =
        {
            get: (loadingId) => this.dataApiCall(ApiPaths.roles, "roles", {itemsPerPage: 200}, {loadingId}),
        };

    specialties =
        {
            get: (page = 0, pageSize = 10, loadingId, filters) => this.dataApiCall(ApiPaths.specialties, "specialties", {
                page: page + 1,
                itemsPerPage: pageSize, ...filters
            }, {loadingId}),
            create: (name, loadingId) => this.dataApiCall(ApiPaths.specialties, "specialties", {name}, {
                method: "POST",
                stateAction: STATE_ACTION_APPEND,
                loadingId
            }),
            edit: (id, name, loadingId) => this.dataApiCall(`${ApiPaths.specialties}/${id}`, "specialties", {name}, {
                method: "PUT",
                stateAction: STATE_ACTION_SEARCH_N_REPLACE,
                loadingId
            }),
            delete: (id, loadingId) => this.dataApiCall(`${ApiPaths.specialties}/${id}`, "specialties", {id}, {
                method: "DELETE",
                stateAction: STATE_ACTION_SEARCH_N_DELETE,
                loadingId
            }),
        };
    fiscalRegimes =
        {
            get: (page = 0, pageSize = 10, loadingId, filters) => this.dataApiCall(ApiPaths.fiscalRegimes, "fiscalRegimes", {
                page: page + 1,
                itemsPerPage: pageSize, ...filters
            }, {loadingId}),
        };

    users =
        {
            get: (page = 0, pageSize = 10, loadingId, filters, customProp) => this.dataApiCall(ApiPaths.users, customProp ? customProp : "users", {
                page: page + 1,
                itemsPerPage: pageSize, ...filters
            }, {loadingId}),
            create: (user, loadingId) => this.dataApiCall(ApiPaths.users, "users", user, {
                method: "POST",
                stateAction: STATE_ACTION_APPEND,
                loadingId
            }),
            edit: (id, properties, loadingId) => this.dataApiCall(`${ApiPaths.users}/${id}`, "users", properties, {
                method: "PUT",
                stateAction: STATE_ACTION_SEARCH_N_REPLACE,
                loadingId
            }),
            delete: (id, loadingId) => this.dataApiCall(`${ApiPaths.users}/${id}`, "users", {id}, {
                method: "DELETE",
                stateAction: STATE_ACTION_SEARCH_N_DELETE,
                loadingId
            }),
            recoverPassword: (email, loadingId) => this.dataApiCall(`${ApiPaths.forgotPassword}/${email}`, "userForgotPassword", {}, {
                method: "PUT",
                stateAction: STATE_ACTION_SET,
                loadingId
            }),
            changePassword: (hash, password, loadingId) => this.dataApiCall(`${ApiPaths.changePassword}/${hash}`, "userChangePassword", {password}, {
                method: "PUT",
                stateAction: STATE_ACTION_SET,
                loadingId
            }),
            sendWelcome: (email, loadingId) => this.dataApiCall(`${ApiPaths.sendWelcome}/${email}`, "sendWelcome", undefined, {
                method: "PUT",
                stateAction: STATE_ACTION_SET,
                loadingId
            }),
        };

    pathToBlob = (path, method = 'GET') => {

        const headers = Object.assign({}, commonHeaders);

        if (this.isSafari && this.token) headers["Authorization"] = "Bearer " + this.token;

        return fetch(
            this.baseUrl + path,
            {
                credentials: 'include',
                headers,
                method,
            })
            .then(response => {

                if (!response || response.status !== 200) {
                    return Promise.reject('File download error');
                }

                return response.blob();
            })
    };

    downloadFile = (path, method = 'GET') => {

        //Fire loading event
        let loadingAction = appLoadingAction();
        this.store.dispatch(loadingAction);

        const headers = Object.assign({}, commonHeaders);

        if (this.isSafari && this.token) headers["Authorization"] = "Bearer " + this.token;

        const config = {};

        return fetch(
            this.baseUrl + path,
            {
                credentials: 'include',
                headers,
                method,
            })
            .then(response => {

                //console.log( response.headers.get('x-file-name') );
                if (response.headers.get('x-file-name'))
                    config.name = response.headers.get('x-file-name');
                //console.log( response.headers.get('Content-Type').split(';')[0] );
                config.type = response.headers.get('Content-Type') ? response.headers.get('Content-Type').split(';')[0] : undefined;

                //Fire end loading event
                let loadingEndAction = appEndLoadingAction();
                this.store.dispatch(loadingEndAction);

                return response.blob()
            })
            .then(blob => download(blob, config.name, config.type))
            .catch((error) => {
                //console.log(error);
                this.store.dispatch(Notifications.error({
                    title: <i className="fa fa-exclamation-triangle"/>,
                    message: 'Error al descargar archivo',
                    autoDismiss: 8
                }));

                //Fire end loading event
                let loadingEndAction = appEndLoadingAction();
                this.store.dispatch(loadingEndAction);
            })


    };

    apiCall = (path, params = {}, method, files) => {

        let query = '';
        let body = undefined;

        if (params || files) {

            if (method === "GET") {
                query = '?' + querySerialize(params);
            }
            //If there are files in the request we build the files object, force a POST request and send the real method in the _method parameter
            else if (files) {

                const formData = new FormData();
                formData.append("_method", method);
                formData.append("data", JSON.stringify(params));
                appendFilesToFormData(formData, files);

                method = "POST";
                body = formData;
            } else if (method === "POST" || method === "PUT") {
                body = JSON.stringify(params);
            }

        }


        const headers = Object.assign({}, commonHeaders);
        if (!files)
            headers["Content-Type"] = "application/json";

        if (this.isSafari && this.token) headers["Authorization"] = "Bearer " + this.token;

        return fetch(
            this.baseUrl + path + query,
            {
                credentials: 'include',
                headers,
                method,
                body
            })

    };

    dataApiCall = (path, property, params, config = {}, files) => {

        //Fire loading event
        let loadingAction = appLoadingAction();
        if (config.loadingId) loadingAction.payload = {id: config.loadingId};
        this.store.dispatch(loadingAction);

        //Default config
        let method = config.method || "GET";
        const stateAction = config.stateAction || STATE_ACTION_SET;

        const successHandler = (data) => {
            this.store.dispatch({

                type: ACTION_PREFIX + stateAction,
                payload: {
                    success: true,
                    property,
                    params,
                    ...data
                }

            });

            //Fire end loading event
            let loadingEndAction = appEndLoadingAction();
            if (config.loadingId) loadingEndAction.payload = {id: config.loadingId};
            this.store.dispatch(loadingEndAction);

            return data.data;
        };

        const errorHandler = (response) => {

            if (response && response.status === 401) {
                //Fire end loading event
                let loadingEndAction = appEndLoadingAction();
                if (config.loadingId) loadingEndAction.payload = {id: config.loadingId};
                this.store.dispatch(loadingEndAction);
                return Promise.reject('Not logged in');
            }

            let message = "Parece que hubo un error.";
            //console.log(response);

            const errorAction = {
                type: ACTION_PREFIX + ACTION_ERROR,
                payload: {
                    property,
                    loadingId: config.loadingId,
                }
            };

            if (response && response.headers &&
                response.headers.get("Content-Type") && (
                    response.headers.get("Content-Type").split(";")[0] === "application/problem+json" ||
                    response.headers.get("Content-Type").split(";")[0] === "application/json")
            ) {
                response.json().then((json) => {

                    //Show error notification
                    this.store.dispatch(Notifications.error({
                        title: <i className="fa fa-exclamation-triangle"/>,
                        message: <span> {message} <br/> {json.detail ? json.detail : null}</span>,
                        autoDismiss: 8
                    }));

                    if (json.detail) errorAction.payload.detail = json.detail;
                    this.store.dispatch(errorAction);

                })
            } else {
                this.store.dispatch(Notifications.error({
                    title: <i className="fa fa-exclamation-triangle"/>,
                    message: message,
                    autoDismiss: 8
                }));

                this.store.dispatch(errorAction);
            }

            //Fire end loading event
            let loadingEndAction = appEndLoadingAction();
            if (config.loadingId) loadingEndAction.payload = {id: config.loadingId};
            this.store.dispatch(loadingEndAction);

            return Promise.reject('Api error');
        };

        const requestFinished = (response) => {

            if (response.status === 401) {
                this.store.dispatch({
                    type: ACTION_PREFIX + ACTION_LOGIN,
                    payload: LOGIN_STATE.NOT_LOGGED

                });
                return Promise.reject(response);
            } else if (response.status >= 400) {

                return Promise.reject(response);
            } else if (response.status === 204) {
                return response;
            } else {
                return response.json()
            }

        };

        return this.apiCall(path, params, method, files)
            .then(requestFinished, requestFinished)
            .then(successHandler, errorHandler);
    };

    clearProperty = (property) => {
        this.store.dispatch({
            type: ACTION_PREFIX + STATE_ACTION_CLEAR,
            payload: {property}
        })
    }

}

/**
 * Append each File inside an object or array to a FormData,
 * for nested objects it will call itself recursively
 *
 * @param formData FormData
 * @param filesObject Array|Object|FileList|File
 * @param basePath String
 */
const appendFilesToFormData = (formData, filesObject, basePath) => {

    if (!filesObject || !formData)
        return;

    if (filesObject.constructor === File)
        formData.append(basePath || 'file', filesObject, filesObject.name);

    else if (filesObject.constructor === Array || filesObject.constructor === FileList)
        for (let i = 0; i < filesObject.length; i++)
            appendFilesToFormData(formData, filesObject[i], (basePath || 'files') + '[]');

    else if (filesObject.constructor === Object)
        for (const key in filesObject)
            appendFilesToFormData(formData, filesObject[key], basePath ? `${basePath}[${key}]` : key);

    else
        throw new Error("Unknown object type sent as file to the api");

};

const querySerialize = (obj) => qs.stringify(obj, {arrayFormat: 'brackets'});

const ApiPaths = {
    annuityPayments: '/api/annuity_payments',
    appFiles: '/api/app_files',
    appFileDownload: '/file/download',
    appFileUrl: '/file',
    certificates: '/api/certificates',
    clocks: '/api/clocks',
    congresses: '/api/congresses',
    congressAttendances: '/api/congress_attendances',
    emailAddresses: '/api/email_addresses',
    emailDocuments: '/api/email_documents',
    emailTemplates: '/api/email_templates',
    emittedCertificates: '/api/emitted_certificates',
    events: '/api/events',
    eventAttendances: '/api/event_attendances',
    fiscalRegimes: '/api/fiscal_regimes',
    logIn: '/api/login_check',
    logOut: '/logout',
    mailerTags: '/api/mailer_tags',
    me: '/api/me',
    people: '/api/people',
    permissions: '/api/permissions',
    unwantedIHSYears: '/api/unwanted_i_h_s_years',
    downloadCredential: (personId, side) => (`/api/people/${personId}/generate_credential_${side}`),
    pdfStatement: (personId) => (`/api/people/statement/${personId}`),
    peopleSimple: '/api/people_simple',
    forgotPassword: '/users/forgot_password',
    specialties: '/api/specialties',
    users: '/api/users',
    changePassword: '/users/set_password_by_hash',
    sendWelcome: '/users/send_welcome',
    sendStatement: '/api/people/send_statement'
};

export const personFullName = ({
                                   name,
                                   patLastName,
                                   matLastName
                               }) => `${name} ${patLastName ? patLastName : ''} ${matLastName ? matLastName : ''}`;


// WEBPACK FOOTER //
// ./src/App/services/Api/index.js